// Helpers de formatage partagés

export function formatBytes(bytes) {
  const n = Number(bytes || 0);
  if (n <= 0) return "0 Mo";
  const mb = n / (1024 * 1024);
  if (mb < 1024) return `${mb.toFixed(mb < 10 ? 1 : 0)} Mo`;
  return `${(mb / 1024).toFixed(2)} Go`;
}

// Libellé lisible pour un statut de radio renvoyé par le backend.
// `t` est la fonction de traduction i18next (react-i18next). Fournie par
// l'appelant pour que les statuts se localisent (clés studio.status.*).
export function statusLabel(status, t) {
  const tr = typeof t === "function" ? t : (k) => k;
  switch ((status || "").toLowerCase()) {
    case "active":
    case "online":
      return { text: tr("studio.status.active"), cls: "bg-green-50 text-green-700" };
    case "provisioning":
      return { text: tr("studio.status.provisioning"), cls: "bg-amber-50 text-amber-700" };
    case "error":
    case "failed":
      return { text: tr("studio.status.error"), cls: "bg-red-50 text-red-700" };
    default:
      return { text: status || tr("studio.status.unknown"), cls: "bg-gray-100 text-gray-500" };
  }
}
